import { Component, HostListener, OnInit } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  NotificationService,
  ProfileService,
  NotificationKeys, 
  ResponseStatus,
  StorageKeys,
  menuListTypes,
  URLS,
  ALTs,
  ProfilePages,
  Directions
} from "@core";
import { AccountType, ProfileMenuOptions, ProfileTabs } from "src/app/core/config/profile-menu.config";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { Router } from "@angular/router";



@Component({
    selector: "app-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.less"],
    standalone: false
})
export class ProfileComponent implements OnInit {
  userId: any;
  disableIdentification!: boolean;
  verifyIdentity!: boolean;
  menuOption: any[] = [...ProfileMenuOptions.filter(m => m.permissions === menuListTypes.GENERAL)];
  profileTabs = ProfileTabs;
  hoveredItem: any = null;
  activePanels: string[] = [];
  screenWidth: number = 0;

  urls = URLS;
  alts = ALTs;
  profilePages = ProfilePages;
  directions = Directions;


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateScreenSize()
  }

  constructor(
    private profileService: ProfileService,
    private notify: NotificationService,
    public msg: NzMessageService,
    private storageSrv: StorageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.checkAccountType();
    this.updateScreenSize();
    this.fetchData();
    this.userId = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!)?.id;
  }

  getUserStatus(value: any) {
    if (
      (value?.additional_detail == null ||
        value?.additional_detail?.identity_verified == false) &&
      value?.provisioned_candidates == 0
    ) {
      this.disableIdentification = true;
    } else if (
      value?.additional_detail?.identity_verified == false &&
      value?.provisioned_candidates > 0
    ) {
      this.disableIdentification = false;
      this.verifyIdentity = true;
    } else if (value?.additional_detail?.identity_verified == true) {
      this.disableIdentification = false;
      this.verifyIdentity = false;
    } else {
      this.disableIdentification = false;
      this.verifyIdentity = false;
    }
  }

  checkAccountType() {
    const accountType = this.storageSrv.getLocalStorageItem(StorageKeys.TOKEN)?.type;

    if (accountType === AccountType.VERIFIER) {
      this.menuOption = [
        ...ProfileMenuOptions
          .filter((m => m.permissions === AccountType.VERIFIER || m.permissions === menuListTypes.GENERAL
          ))]
    }

    if (accountType === AccountType.USER) {
      this.menuOption = [
        ...ProfileMenuOptions
          .filter((m => m.permissions === AccountType.USER || m.permissions === menuListTypes.GENERAL
          ))]
    }
  }

  fetchData() {
    this.profileService
      .getUser()
      .then((res: any) => {
        if (res?.status == ResponseStatus.FAILED) {
          this.notify.error("", res?.message, NotificationKeys.PROFILE);
          return;
        }

        this.getUserStatus(res?.data);
      })
      .catch((err: any) => {
        console.warn(err);
      });
  }

  onPanelToggle(isActive: boolean, link: string) {
    if(isActive) {
     this.activePanels = [link];
    } else {
      this.activePanels = this.activePanels.filter(panel => panel !== link);
    }
  }

  isPanelActive(panelLink: string): boolean {
    return this.activePanels.includes(panelLink);
  }
  

  navigateToPanel(link: string) {
    this.router.navigate([link]);
  }

  private updateScreenSize() {
    this.screenWidth = window.innerWidth;
  }
  
}
